const defer = function () {
    const deferred = {
        resolve: undefined,
        reject: undefined,
        promise: undefined,
    };
    const promise = new Promise(function (resolve, reject) {
        deferred.resolve = resolve;
        // note : we need this to prevent onReject errors when handling promises
        // note: reverted otherwise promise is never rejected
        deferred.reject = reject;
    });
    deferred.promise = promise;
    return deferred;
};
export default defer;
